import { createAction, props } from '@ngrx/store';
import { IAmountData, IAmountModel } from '@partners/api';

export class AmountActions {
  static reset = createAction('[Amount] Reset State');
  static load = createAction('[Amount] Load');
  static loadSuccess = createAction('[Amount] Load Success', props<{ model: IAmountModel; data: IAmountData }>());
  static loadFailure = createAction('[Amount] Load Failure', props<{ error: any }>());
  static submit = createAction('[Amount] Submit');
  static submitSuccess = createAction('[Amount] Submit Success', props<{ model: IAmountModel }>());
  static submitFailure = createAction('[Amount] Submit Failure', props<{ error: any }>());
}
